import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-6774f2d7")

_pushScopeId("data-v-6774f2d7")
const _hoisted_1 = { class: "answer-container" }
const _hoisted_2 = { class: "rank-wrapper" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "当前", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", null, "排名", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", null, "活动规则", -1)
const _hoisted_6 = { class: "index-title" }
const _hoisted_7 = { class: "index-cover" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Close = _resolveComponent("Close")
  const _component_Action = _resolveComponent("Action")
  const _component_PopInner = _resolveComponent("PopInner")

  return (_openBlock(), _createBlock(_component_PopInner, {
    flowerLeft: true,
    light: true,
    spot: true
  }, {
    default: _withId(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_Close, { onAction: _ctx.close }, null, 8, ["onAction"]),
        _createVNode("div", _hoisted_2, [
          _createVNode("div", {
            class: "rank-left",
            onClick: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goRank && _ctx.goRank(...args)), ["stop","prevent"]))
          }, [
            _hoisted_3,
            _hoisted_4
          ]),
          _createVNode("div", {
            class: "rank-right",
            onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goRank && _ctx.goRank(...args)), ["stop","prevent"]))
          }, [
            _createVNode("span", null, _toDisplayString(_ctx.rank), 1)
          ])
        ]),
        _createVNode("div", {
          class: "rule-wrapper",
          onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.goRule && _ctx.goRule(...args)), ["stop","prevent"]))
        }, [
          _hoisted_5
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("img", {
            src: `${_ctx.rootUrl}/answer/index_title.png`
          }, null, 8, ["src"])
        ]),
        _createVNode("div", _hoisted_7, [
          _createVNode("img", {
            src: `${_ctx.rootUrl}/answer/index_cover.png`
          }, null, 8, ["src"])
        ]),
        _createVNode(_component_Action, {
          class: "action-first",
          text: `幸运抽奖`,
          icon: `${_ctx.rootUrl}/answer/index_action_arrow.png`,
          onAction: _ctx.goDraw
        }, null, 8, ["icon", "onAction"]),
        _createVNode(_component_Action, {
          class: "action-second",
          text: `每日答题`,
          icon: `${_ctx.rootUrl}/answer/index_action_arrow.png`,
          style: `blue`,
          onAction: _ctx.goAnswer
        }, null, 8, ["icon", "onAction"])
      ])
    ]),
    _: 1
  }))
})